export default __webpack_public_path__ + "static/media/microbe.a290172b.png";